

import { default as React } from "react";

import { WithTranslation, withTranslation } from "react-i18next";
import { AllocationConstraintDto } from "core/backend/data";

interface OwnProps {
    data: AllocationConstraintDto[];
}

const Disclaimer = ({ t, data }: OwnProps & WithTranslation) => {
    return data.filter(d => d.allocationConstraintImport === 12000).length > 0
        ? <span style={{ textAlign: "right", marginRight: "10px", marginTop: "-25px", zIndex: 5 }}>
            {t("ibwt_allocationConstraint:noAppliedLimitations")}
        </span>
        : null;
};

const translated = withTranslation()(Disclaimer);

export default translated;